import { genericPage, getServerSidePropsHelper } from 'components/3cat/Page';
import { useRouter } from 'next/router';
// /ultims-dies/[tv3|324|sx3|33|esport3|tv3cat|3cat]/
const path = ['web', process.env.FOLDER_LAYOUTS, 'ultims-dies', 'canal'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    return getServerSidePropsHelper(context, { slugs: path });
}

export default Pagina;
